import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Remove tudo que não é dígito (0-9)
export function normalizarTelefone(telefone: string): string {
  return telefone.replace(/\D/g, '');
}

// Converte para minúsculas e remove acentos/diacríticos
export function normalizarTexto(texto: string): string {
  return texto
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
